import ColorScheme from '../ColorScheme/ColorScheme';

const disabled = {
    backgroundDisabled: 'sf-gray-300',
    colorDisabled: 'sf-white',
    iconColorDisabled: 'white',
    borderDisabled: undefined
};

const disabledClear = {
    backgroundDisabled: 'sf-white',
    colorDisabled: 'sf-gray-300',
    borderDisabled: 'sf-gray-300',
    iconColorDisabled: ColorScheme['sf-gray-300']
};

export const ButtonStylesSettings = {
    Primary: {
        color: 'sf-primary-500',
        background: 'sf-white',
        border: 'sf-gray-200',
        backgroundHover: 'sf-white',
        borderHover: 'sf-primary-500',
        borderFocus: 'sf-primary-300',
        iconColor: ColorScheme['sf-primary-500'],
        ...disabledClear
    },
    Tertiary: {
        color: 'sf-gray-700',
        background: 'sf-white',
        border: 'sf-gray-200',
        backgroundHover: 'sf-white',
        borderHover: 'sf-gray-700',
        borderFocus: 'sf-gray-500',
        iconColor: ColorScheme['sf-gray-700'],
        ...disabledClear
    },
    Danger: {
        color: 'sf-negative-500',
        background: 'sf-white',
        border: 'sf-gray-200',
        backgroundHover: 'sf-white',
        borderHover: 'sf-negative-500',
        borderFocus: 'sf-negative-300',
        iconColor: ColorScheme['sf-negative-500'],
        ...disabledClear
    },
    Ghost: {
        color: 'sf-white',
        background: 'transparent',
        border: 'transparent',
        backgroundHover: 'transparent',
        borderHover: 'transparent',
        borderFocus: 'sf-gray-300',
        iconColor: ColorScheme['sf-gray-300'],
        ...disabledClear
    },
    PrimarySolid: {
        color: 'sf-white',
        background: 'sf-primary-500',
        border: undefined,
        backgroundHover: 'sf-primary-700',
        borderHover: undefined,
        borderFocus: 'sf-primary-300',
        iconColor: 'white',
        ...disabled
    },
    GhostSolid: {
        color: 'sf-white',
        background: 'sf-gray-700',
        border: undefined,
        backgroundHover: 'sf-gray-900',
        borderHover: undefined,
        borderFocus: 'sf-gray-500',
        iconColor: 'white',
        ...disabled
    },
    DangerSolid: {
        color: 'sf-white',
        background: 'sf-negative-500',
        border: undefined,
        backgroundHover: 'sf-negative-600',
        borderHover: undefined,
        borderFocus: 'sf-negative-300',
        iconColor: 'white',
        ...disabled
    },
    TertiarySolid: {
        color: 'sf-gray-700',
        background: 'sf-white',
        border: undefined,
        backgroundHover: 'sf-gray-100',
        borderHover: undefined,
        borderFocus: 'sf-gray-200',
        iconColor: ColorScheme['sf-gray-700'],
        ...disabled
    }
};

export const ButtonLinkStylesSettings = {
    Primary: {
        color: 'sf-primary-500',
        colorHover: 'sf-primary-700',
        colorDisabled: 'sf-primary-300',
        border: 'border-none',
        borderWidth: '',
        ...disabledClear
    },
    Underline: {
        color: 'sf-gray-500',
        colorHover: 'sf-gray-700',
        colorDisabled: 'sf-gray-200',
        border: 'border-b',
        borderWidth: '',
        ...disabledClear
    }
};

const ButtonStyles = {
    TertiarySolid: 'TertiarySolid',
    DangerSolid: 'DangerSolid',
    GhostSolid: 'GhostSolid',
    PrimarySolid: 'PrimarySolid',
    Tertiary: 'Tertiary',
    Danger: 'Danger',
    Ghost: 'Ghost',
    Primary: 'Primary'
};

export default ButtonStyles;
